import { FaWhatsapp } from "react-icons/fa";

const Whatsapp = () => {
  // country code + number (no +, no spaces)
  const message = "Hello, I would like to enquire about your services.";

  const whatsappUrl = `https://wa.me/${9582730030}?text=${encodeURIComponent(
    message
  )}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 rounded-full bg-green-500 hover:bg-green-600 shadow-lg transition-transform duration-300 hover:scale-110"
    >
      <FaWhatsapp className="text-white text-3xl" />
    </a>
  );
};

export default Whatsapp;
